<div *ngIf="isRetrying" class="c-icons">
    <i class="fas fa-spinner fa-pulse"></i>
</div>
<div *ngIf="isError" class="c-icons">
    <i class="fa fa-exclamation-triangle"></i>
</div>

<img [src]="imgSrc" *ngIf="isImageLoaded">
<img [src]="imgSrc" *ngIf="!isImageLoaded && !!imgSrc" data-max-retry="2" data-retry="0"
    (load)="imgOnload($event)" (error)="waitAndReload($event)" hidden>